import { format } from "date-fns";

export /**
 *
 * Formats the date nicely
 * @param {(string | Date)} date
 * @return {*}
 */
const formatPasswordChangeDate = (date) => {
  const newDate = new Date(date);
  return format(newDate, "MMM d, yyyy HH.mm");
};
